var React = require('react');

function TA (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n    .st0 {\n      fill: #fff;\n    }\n  "),React.createElement("path",{"className":"st0","d":"M1.3 15.7h.3l1-12.9h5.5v27.7l-4.2 2.9v.3l4.7-1.2 4.5 1.2v-.3L9 30.5V2.8h5.5l1.1 12.8v.1h.3V2.2H1.3zM33.5 30.3 27 .8l-5.9 29.5-4 3.1v.3l4.1-1.2 4.4 1.2v-.3l-3.9-3.1 1.9-9.6h6.8l2.1 9.6-3.9 3v.3l4.4-1.2 4.3 1.1h.1v-.3l-3.9-2.9zm-3.2-10.2h-6.6l3.1-15.6 3.5 15.6z","key":1})]);
}

TA.defaultProps = {"version":"1.1","id":"Layer_1","x":"0","y":"0","viewBox":"0 0 38.5 35","style":{"enableBackground":"new 0 0 38.5 35"},"xmlSpace":"preserve"};

module.exports = TA;

TA.default = TA;
